import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "wrapper" }

import SpaceShip from "@/components/MainPage/PcVersion/SpaceShip.vue";
import ScoutsLogo from "@/components/Common/ScoutsLogo.vue";
import GreetingsHolder from "@/components/MainPage/PcVersion/GreetingsHolder.vue";
import RegisterButton2 from "@/components/MainPage/PcVersion/RegisterButton2.vue";
import TestDescription from "@/components/MainPage/PcVersion/TestDescription.vue";
import ReferralProgramDescription from "@/components/MainPage/PcVersion/ReferralProgramDescription.vue";
import ContentHolder from "@/components/MainPage/PcVersion/ContentHolder.vue";

import { defineComponent } from 'vue'

const __default__ = defineComponent({
    name: 'MainPagePcVersion',
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SpaceShip),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ScoutsLogo),
      _createVNode(GreetingsHolder),
      _createVNode(RegisterButton2),
      _createVNode(ContentHolder),
      _createVNode(TestDescription),
      _createVNode(RegisterButton2),
      _createVNode(ReferralProgramDescription),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "paddingWorkaround noselect" }, "не, ну это костыль", -1))
    ])
  ]))
}
}

})